<template>
  <div id="app">
   <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  
  components: {
  },
  mounted() {
    document.title = '红包商城运营管理后台'
    // console.log(this.)
    // this.getUserInfo()
  },
  methods: {
  }
}
</script>

<style>
body {
  background-color: #f4f8ff;
  overflow: hidden;
}
.dialog{
  padding-bottom: 20px;
}
</style>
